var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-column-container py-4 px-3 d-flex justify-center align-center cursor-pointer blue-grey--text",on:{"click":function($event){return _vm.$emit('add')}}},[_c('v-icon',{staticClass:"mr-1",attrs:{"size":"16","color":"blue-grey"}},[_vm._v("mdi-plus-circle-outline")]),_vm._v("\n  "+_vm._s(_vm.$t('boards.add_column'))+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }